import { render, staticRenderFns } from "./CreditNotesList.vue?vue&type=template&id=b4ab43f2&"
import script from "./CreditNotesList.vue?vue&type=script&lang=js&"
export * from "./CreditNotesList.vue?vue&type=script&lang=js&"
import style0 from "./CreditNotesList.vue?vue&type=style&index=0&id=b4ab43f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports